import React from "react";

export const EditIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.1741 6.81238C21.7028 6.2838 21.9998 5.56685 21.9999 4.81923C22 4.07162 21.7031 3.35459 21.1746 2.82588C20.646 2.29717 19.929 2.00009 19.1814 2C18.4338 1.99991 17.7168 2.2968 17.1881 2.82538L3.84206 16.1744C3.60988 16.4059 3.43817 16.6909 3.34206 17.0044L2.02106 21.3564C1.99521 21.4429 1.99326 21.5347 2.01541 21.6222C2.03756 21.7097 2.08298 21.7896 2.14685 21.8534C2.21073 21.9172 2.29068 21.9624 2.37821 21.9845C2.46575 22.0065 2.55762 22.0044 2.64406 21.9784L6.99706 20.6584C7.31023 20.5631 7.59523 20.3925 7.82706 20.1614L21.1741 6.81238Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 5L19 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
